module.exports = __webpack_public_path__ + "static/media/authPic.df049ced.png";